export default __webpack_public_path__ + "static/media/indiana.98138205.jpg";